import React from 'react';
import {
    Box,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from '@mui/material';
import DoneIcon from '@mui/icons-material/Done';
import CloseIcon from '@mui/icons-material/Close';
function Step2() {
    const requirements = [
        { id: 1, name: 'All orders delivered', status: true },
        { id: 2, name: 'All payouts completed', status: false },
        { id: 3, name: 'Wallet balance cleared', status: false },
        { id: 4, name: 'Subscriptions canceled', status: true },
        { id: 5, name: 'Active ads or promotions', status: false },
    ];

    return (
        <>
            <div className="form">
                <div className="gap_p">
                    <div className="control_group">
                        <h3 className="hd_6">Confirmation Screen</h3>
                    </div>
                </div>
            </div>

            <TableContainer className="table_container mt_20">
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><b>Requirement</b></TableCell>
                            <TableCell><b>Status</b></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {requirements.map((req) => (
                            <TableRow key={req.id} hover>
                                <TableCell>{req.name}</TableCell>
                                <TableCell>
                                    {req.status ? (
                                        <DoneIcon/>
                                    ) : (
                                    <CloseIcon/>
                                        )}
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
             <h4 className="mt_20 text_center">You still have active orders or pending payouts. Please complete these before requesting permanent closure.</h4>
           
        </>
    );
}

export default Step2;
